// Simple motion service that emits tick updates with delta time in seconds

// Type declaration for HMR
declare const module: {
  hot?: {
    dispose: (callback: () => void) => void;
    accept: (callback: () => void) => void;
  };
};

class MotionService {
  private isEnabled: boolean = false;
  private tickHandler?: (deltaSeconds: number) => void;
  private isHMR: boolean = false;
  private rafId: number | null = null;
  private lastTimeMs: number | null = null;

  constructor() {
    if (typeof module !== "undefined" && module.hot) {
      module.hot.dispose(() => {
        this.disable();
        this.isHMR = true;
      });

      module.hot.accept(() => {
        if (this.isHMR) {
          this.isHMR = false;
          if (this.isEnabled) {
            this.enable();
          }
        }
      });
    }
  }

  onTick(handler: (deltaSeconds: number) => void) {
    this.tickHandler = handler;
  }

  enable() {
    if (this.isEnabled) {
      this.disable();
    }
    this.isEnabled = true;
    this.lastTimeMs = null;
    const loop = (now: number) => {
      if (!this.isEnabled) return;
      if (this.lastTimeMs === null) {
        this.lastTimeMs = now;
      }
      const deltaSeconds = Math.max(0, (now - this.lastTimeMs) / 1000);
      this.lastTimeMs = now;
      if (this.tickHandler) {
        this.tickHandler(deltaSeconds);
      }
      this.rafId = requestAnimationFrame(loop);
    };
    this.rafId = requestAnimationFrame(loop);
  }

  disable() {
    if (!this.isEnabled) return;
    this.isEnabled = false;
    this.tickHandler = undefined;
    this.lastTimeMs = null;
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
  }
}

export const motionService = new MotionService();
